[
	{
		"display": "true",
		"ui_columnname": "Leg RefID",
		"db_columnname": "legRefID",
		"datatype": "String",
		"mappingkey": "legRefID",
		"dropdown": "NO",
		"isdefault": "false",
		"disabled": "false",
		"value": "",
		"dropdowntype": "",
		"dropdownvalue": ""
	},
	{
		"display": "true",
		"ui_columnname": "Symbol",
		"db_columnname": "symbol",
		"datatype": "String",
		"mappingkey": "symbol",
		"dropdown": "NO",
		"isdefault": "false",
		"disabled": "false",
		"value": "",
		"dropdowntype": "",
		"dropdownvalue": ""
	},
	{
		"display": "true",
		"ui_columnname": "OptionID",
		"db_columnname": "optionID",
		"datatype": "String",
		"mappingkey": "optionID",
		"dropdown": "NO",
		"isdefault": "false",
		"disabled": "false",
		"value": "",
		"dropdowntype": "",
		"dropdownvalue": ""
	},
	{
		"display": "true",
		"ui_columnname": "OpenCloseIndicator",
		"db_columnname": "openCloseIndicator",
		"datatype": "String",
		"mappingkey": "openCloseIndicator",
		"dropdown": "Yes",
		"isdefault": "false",
		"disabled": "false",
		"value": "",
		"dropdowntype": "singleselect",
		"dropdownvalue": ""
	},
	{
		"display": "true",
		"ui_columnname": "Side",
		"db_columnname": "side",
		"datatype": "String",
		"mappingkey": "side",
		"dropdown": "Yes",
		"isdefault": "false",
		"disabled": "false",
		"value": "",
		"dropdowntype": "singleselect",
		"dropdownvalue": ""
	},
	{
		"display": "true",
		"ui_columnname": "LegRatioQuantity",
		"db_columnname": "legRatioQuantity",
		"datatype": "Int",
		"mappingkey": "legRatioQuantity",
		"dropdown": "NO",
		"isdefault": "false",
		"disabled": "false",
		"value": "",
		"dropdowntype": "",
		"dropdownvalue": ""
	}
]